import { USER_TYPES } from "./userTypes";

export const normalizeRoles = (value) => {
  if (Array.isArray(value)) return value.flatMap(normalizeRoles);
  if (value == null) return [];
  return [String(value).trim()].filter(Boolean);
};

const moduleActions = (module) => {
  if (!module) return [];
  const submoduleActions = (module.submodules || []).flatMap((sub) => sub.actions || []);
  return [...(module.actions || []), ...submoduleActions];
};

export const hasViewPermission = (permissions, group, modulePageUrl) => {
  const module = (permissions || []).find(
    (item) =>
      String(item.group || "").toLowerCase() === String(group).toLowerCase() &&
      String(item.modulePageUrl || "").toLowerCase() === String(modulePageUrl).toLowerCase()
  );
  return moduleActions(module).some(
    (action) =>
      action.roleIsActive && String(action.action || "").toLowerCase().includes("view")
  );
};

export const hasSubmoduleViewPermission = (permissions, group, modulePageUrl, submodulePageUrl) => {
  const module = (permissions || []).find(
    (item) =>
      String(item.group || "").toLowerCase() === String(group).toLowerCase() &&
      String(item.modulePageUrl || "").toLowerCase() === String(modulePageUrl).toLowerCase()
  );
  const submodule = (module?.submodules || []).find(
    (item) =>
      String(item.modulePageUrl || "").toLowerCase() === String(submodulePageUrl).toLowerCase() ||
      String(item.modulePage || "").toLowerCase() === String(submodulePageUrl).toLowerCase()
  );
  return moduleActions(submodule).some(
    (action) =>
      action.roleIsActive && String(action.action || "").toLowerCase().includes("view")
  );
};

export const hasDashboardPermission = (permissions) =>
  (permissions || []).some((item) => {
    const moduleUrl = String(item?.modulePageUrl || "").toLowerCase();
    const group = String(item?.group || "").toLowerCase();
    const moduleName = String(item?.modulePage || "").toLowerCase();

    return moduleUrl === "dashboard" || group === "dashboard" || moduleName === "dashboard";
  });

const isAdminRoleLabel = (role) => {
  const label = String(role).trim().toLowerCase();
  return label.includes("super") || label === "admin" || label.endsWith(" admin");
};

export const isOperatorUser = (userTypes, roles) =>
  userTypes.includes(USER_TYPES.OPERATOR) ||
  roles.some((role) => String(role).toLowerCase().includes("operator"));

export const isAdminUser = (userTypes, roles) =>
  userTypes.includes(USER_TYPES.SUPERUSER) || roles.some(isAdminRoleLabel);

export const isSalesUser = (roles, permissions) =>
  roles.some((role) => String(role).toLowerCase().includes("sales")) ||
  hasViewPermission(permissions, "sales", "leads");

export const isIssuanceUser = (roles, permissions) =>
  roles.some((role) => String(role).toLowerCase().includes("issuance")) ||
  hasViewPermission(permissions, "issuance", "issuance");

export const isClaimsUser = (roles, permissions) =>
  roles.some((role) => String(role).toLowerCase().includes("claims")) ||
  hasViewPermission(permissions, "claims", "claims");

export const canViewSalesOverviewTab = (auth) => {
  const userTypes = normalizeRoles(auth?.user_type);
  const roles = normalizeRoles(auth?.role);
  const permissions = auth?.permission || [];

  if (userTypes.includes(USER_TYPES.SUPERUSER) || roles.some(isAdminRoleLabel)) {
    return true;
  }

  return hasSubmoduleViewPermission(permissions, "sales", "leads", "overview");
};
